import { motion } from "framer-motion";
import React from "react";
import CountUp from "react-countup";
import { pageTransition, pageVariants } from "../../hooks/pagetransition";
import "./Impact.css";

const Impact = () => {
  return (
    <motion.table
      className="impactTable"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <tr className="hidden">
        <td>test</td>
        <td>test</td>
      </tr>
      <tr>
        <td>
          <span className="countNumber">
            <CountUp end={27} duration={3} />
          </span>{" "}
          Greensight
        </td>
        <td></td>
      </tr>
      <tr className="hidden">
        <td>test</td>
        <td>test</td>
      </tr>
      <tr>
        <td></td>
        <td>
          <span className="countNumber">
            <CountUp end={32} duration={3} />
          </span>{" "}
          Climate Stream
        </td>
      </tr>
      <tr className="hidden">
        <td>test</td>
        <td>test</td>
      </tr>
      <tr>
        <td>
          <span className="countNumber">
            <CountUp end={5} duration={3} />
          </span>{" "}
          Videos
        </td>
        <td></td>
      </tr>
      <tr className="hidden">
        <td>test</td>
        <td>test</td>
      </tr>
      <tr>
        <td></td>
        <td>
          <span className="countNumber">
            <CountUp end={15} duration={3} />
          </span>{" "}
          Blogs
        </td>
      </tr>
      <tr className="hidden">
        <td>test</td>
        <td>test</td>
      </tr>
    </motion.table>
  );
};

export default Impact;
